import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import AccessLogCard from '../AccessLogCard'
import { useDoorData } from '../context/DoorContext'
import DoorItem from '../DoorItem'
import EmergencyButtons from '../EmergencyButtons'
import { Flex, Grid, Box } from '@chakra-ui/react'
function Dashboard() {

    const { user } = useDoorData()
    const navigate = useNavigate()

    useEffect(() => {
        if(!user) {
          navigate("/login");
        }
      }, [user])
    

  // return (
  //   <Grid mx="5vw" gap={6}>
  //   <EmergencyButtons/>
  //   <DoorItem/>
  //   <AccessLogCard/>
  //   </Grid>
  // )
  return (
    <Flex direction="column" minH="100vh">
      
      {/* Viršutinė dalis — visas dashboard turinys */}
      <Box flex="1" mx="5vw" mt={4}>
        <EmergencyButtons/>
        <DoorItem/>
      </Box>

      {/* Apačioje prilipęs log komponentas */}
      <Box position="sticky" bottom="0" zIndex="20" bg="white">
        <AccessLogCard />
      </Box>
    </Flex>
  )

}

export default Dashboard